import React, { useState } from 'react';
import LoyaltyStatsBento from '../loyalty/LoyaltyStatsBento';
import LoyaltyProgramsGrid from '../loyalty/LoyaltyProgramsGrid';
import RecentActivityList from '../loyalty/RecentActivityList';
import AddProgramModal from '../loyalty/AddProgramModal';
import AddActivityModal from '../loyalty/AddActivityModal';

function LoyaltyTab({ onNavigateToTransferReference }) {
  const [showAddProgram, setShowAddProgram] = useState(false);
  const [showLogActivity, setShowLogActivity] = useState(false);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between pt-2">
        <div>
          <h1 className="text-2xl font-bold text-on-surface tracking-display">Loyalty</h1>
          <p className="text-sm text-on-surface-variant mt-1">
            Track programs & maximize rewards
          </p>
        </div>
        <button
          className="flex items-center gap-1.5 px-4 py-2.5 bg-primary text-on-primary text-sm font-semibold rounded-full shadow-bento hover:shadow-bento-hover hover:bg-primary-dark transition-all active:scale-[0.97] duration-200"
          onClick={() => setShowAddProgram(true)}
        >
          <span className="material-symbols-outlined" style={{ fontSize: 18 }}>add</span>
          Add Program
        </button>
      </div>

      {/* Stats Bento Grid */}
      <LoyaltyStatsBento />

      {/* Active Programs */}
      <LoyaltyProgramsGrid onAddProgram={() => setShowAddProgram(true)} />

      {/* Recent Activity */}
      <RecentActivityList onLogActivity={() => setShowLogActivity(true)} />

      {/* Modals */}
      {showAddProgram && <AddProgramModal onClose={() => setShowAddProgram(false)} />}
      {showLogActivity && <AddActivityModal onClose={() => setShowLogActivity(false)} />}
    </div>
  );
}

export default LoyaltyTab;
